import React from 'react';
import styles from './BranchDetail.module.css';
import ReleaseIdentityStrip from '../components/releases/ReleaseIdentityStrip';
import BuildStepsSection from '../components/releases/BuildStepsSection';
import PostReleaseSection from '../components/releases/PostReleaseSection';
import ValidateBinariesSection from '../components/releases/ValidateBinariesSection';
import TriggerVersionBumpDialog from '../components/releases/TriggerVersionBumpDialog';
import BranchDrawer from '../components/branches/BranchDrawer';
import ReleaseNotesSection from '../components/releases/ReleaseNotesSection';

export default function ReleaseBranchDetail({ data, reloadData, navigate }) {
  const { loaded, release, error } = data;
  const [drawerStack, setDrawerStack] = React.useState([]);
  const [bumpDialogOpen, setBumpDialogOpen] = React.useState(false);

  const pushDrawer  = (entry) => setDrawerStack((s) => [...s, entry]);
  const popDrawer   = ()      => setDrawerStack((s) => s.slice(0, -1));
  const popToDrawer = (index) => setDrawerStack((s) => s.slice(0, index + 1));
  const closeDrawer = ()      => setDrawerStack([]);

  if (!loaded) {
    return (
      <div className={styles.loading}>
        <div className={styles.loadingSpinner} />
        Loading release…
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.errorPage}>
        <div className={styles.errorTitle}>Failed to load release</div>
        <div className={styles.errorMsg}>{String(error)}</div>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <ReleaseIdentityStrip release={release} reloadData={reloadData} navigate={navigate} />
      <div className={styles.inner}>
        <BuildStepsSection
          buildStatus={release.build_status}
          onOpenOp={({ component, step }) => pushDrawer({
            kind: 'op',
            id: step.operation_id,
            name: component,
            data: {
              ...step,
              component,
              name: step.label,
              stepName: step.name,
              label: step.label,
              stage: 'release',
            },
          })}
        />

        <ReleaseNotesSection version={release.version} />

        <ValidateBinariesSection release={release} onValidated={reloadData} />

        <PostReleaseSection
          release={release}
          onOpenOp={({ component, op }) => pushDrawer({
            kind: 'op',
            id: op.operation_id,
            name: component,
            data: { ...op, component, name: component },
          })}
          onTrigger={() => setBumpDialogOpen(true)}
        />
      </div>

      <BranchDrawer
        drawerStack={drawerStack}
        onPush={pushDrawer}
        onPop={popDrawer}
        onPopTo={popToDrawer}
        onClose={closeDrawer}
        version={release.branch_version}
        releaseVersion={release.version}
      />

      <TriggerVersionBumpDialog
        open={bumpDialogOpen}
        onClose={() => setBumpDialogOpen(false)}
        release={release}
        onTriggered={reloadData}
      />
    </div>
  );
}
